/**
 * @generated SignedSource<<abb97399bcc4e02a232c72b406cc723f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MATInternalLoginTypeUpdateInput = {
  id: string;
  loginId: string;
  password: string;
};
export type InternalLoginTypeUpdateDialog_internalLoginTypeUpdateMutation$variables = {
  input: MATInternalLoginTypeUpdateInput;
};
export type InternalLoginTypeUpdateDialog_internalLoginTypeUpdateMutation$data = {
  readonly internalLoginTypeUpdate: {
    readonly id: string;
    readonly loginId: string;
  };
};
export type InternalLoginTypeUpdateDialog_internalLoginTypeUpdateMutation = {
  response: InternalLoginTypeUpdateDialog_internalLoginTypeUpdateMutation$data;
  variables: InternalLoginTypeUpdateDialog_internalLoginTypeUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MATInternalUser",
    "kind": "LinkedField",
    "name": "internalLoginTypeUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "loginId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternalLoginTypeUpdateDialog_internalLoginTypeUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternalLoginTypeUpdateDialog_internalLoginTypeUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d8fa55a15371034faead3851692044cf",
    "id": null,
    "metadata": {},
    "name": "InternalLoginTypeUpdateDialog_internalLoginTypeUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation InternalLoginTypeUpdateDialog_internalLoginTypeUpdateMutation(\n  $input: MATInternalLoginTypeUpdateInput!\n) {\n  internalLoginTypeUpdate(input: $input) {\n    id\n    loginId\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8bd9d5fd7daf95a3c17e60a510fbcfb";

export default node;
